<template>
  <HScaffold :title="'添加'+props['name']">
    <div class="tAddWithdrawParentDiv">
      <van-cell-group inset>
        <van-field
            clearable
            @input="checkLoginBtnVisible"
            v-for="(item,index) in allInputInfos"
            :key="index"
            :disabled="item['isCantEdit']??false"
            v-model="values[index]"
            :label="item['title']"
            :type="item['keyboardType']"
            label-width="60px"
            label-align="right"
            :placeholder="item['hintText']"
        >
          <template v-if="item['rightText'] && item['rightText']!==''" #button>
            <div @click="item['rightCallback']" :style="hcf.getTextStyle({
              color:'main'
            })">{{ item['rightText'] }}
            </div>
          </template>
        </van-field>
      </van-cell-group>
      <HButton :disabled="!isCanPressOkBtn" title="确认保存" :callback="clickSaveBtn"/>
    </div>
    <van-action-sheet :closeable="false" v-model:show="showSelectModal" title="选择开户行"
                      style="height:53%;background-color: var(--ct-main-bg-color)">
      <div @click="clickSelect(item.value)" v-for="item in selectInfos" :key="item.label"
           style="border-radius: 5px;margin:10px;display:flex;flex-direction: row;align-items: center;padding:13px;">
        <img :src="item.icon" alt="" style="height:23px;">
        <div :style="hcf.getTextStyle({
          marginLeft:10,
      })">{{ item.label }}
        </div>
      </div>
    </van-action-sheet>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {hr} from "@/components/utils/HRouter.js";
  import {useUserStore} from "@/stores/useUser.js";
  import icon_bank_003 from "@/assets/icons/bank/icon_bank_003.png";
  import icon_bank_004 from "@/assets/icons/bank/icon_bank_004.png";
  import icon_bank_009 from "@/assets/icons/bank/icon_bank_009.png";
  import icon_bank_002 from "@/assets/icons/bank/icon_bank_002.png";
  import icon_bank_005 from "@/assets/icons/bank/icon_bank_005.png";
  import icon_bank_006 from "@/assets/icons/bank/icon_bank_006.png";
  import icon_bank_007 from "@/assets/icons/bank/icon_bank_007.png";
  import icon_bank_008 from "@/assets/icons/bank/icon_bank_008.png";
  import icon_bank_039 from "@/assets/icons/bank/icon_bank_039.png";
  import icon_bank_017 from "@/assets/icons/bank/icon_bank_017.png";
  import icon_bank_016 from "@/assets/icons/bank/icon_bank_016.png";
  import icon_bank_040 from "@/assets/icons/bank/icon_bank_040.png";
  import icon_bank_041 from "@/assets/icons/bank/icon_bank_041.png";
  import icon_bank_042 from "@/assets/icons/bank/icon_bank_042.png";
  import icon_bank_043 from "@/assets/icons/bank/icon_bank_043.png";
  import icon_bank_044 from "@/assets/icons/bank/icon_bank_044.png";
  import icon_bank_045 from "@/assets/icons/bank/icon_bank_045.png";
  import icon_bank_046 from "@/assets/icons/bank/icon_bank_046.png";
  import icon_bank_047 from "@/assets/icons/bank/icon_bank_047.png";
  import icon_bank_048 from "@/assets/icons/bank/icon_bank_048.png";
  import icon_bank_049 from "@/assets/icons/bank/icon_bank_049.png";
  import icon_bank_050 from "@/assets/icons/bank/icon_bank_050.png";
  import icon_bank_051 from "@/assets/icons/bank/icon_bank_051.png";
  import icon_bank_052 from "@/assets/icons/bank/icon_bank_052.png";
  import icon_bank_053 from "@/assets/icons/bank/icon_bank_053.png";
  import icon_bank_054 from "@/assets/icons/bank/icon_bank_054.png";
  import icon_bank_055 from "@/assets/icons/bank/icon_bank_055.png";
  import icon_bank_018 from "@/assets/icons/bank/icon_bank_018.png";
  import icon_bank_019 from "@/assets/icons/bank/icon_bank_019.png";
  import icon_bank_010 from "@/assets/icons/bank/icon_bank_010.png";
  import icon_bank_011 from "@/assets/icons/bank/icon_bank_011.png";
  import icon_bank_028 from "@/assets/icons/bank/icon_bank_028.png";
  import icon_bank_012 from "@/assets/icons/bank/icon_bank_012.png";
  import icon_bank_013 from "@/assets/icons/bank/icon_bank_013.png";
  import icon_bank_014 from "@/assets/icons/bank/icon_bank_014.png";
  import icon_bank_015 from "@/assets/icons/bank/icon_bank_015.png";
  import icon_bank_024 from "@/assets/icons/bank/icon_bank_024.png";
  import icon_bank_026 from "@/assets/icons/bank/icon_bank_026.png";
  import icon_bank_027 from "@/assets/icons/bank/icon_bank_027.png";
  import icon_bank_023 from "@/assets/icons/bank/icon_bank_023.png";
  import icon_bank_031 from "@/assets/icons/bank/icon_bank_031.png";
  import icon_bank_032 from "@/assets/icons/bank/icon_bank_032.png";
  import icon_bank_033 from "@/assets/icons/bank/icon_bank_033.png";
  import icon_bank_034 from "@/assets/icons/bank/icon_bank_034.png";
  import icon_bank_035 from "@/assets/icons/bank/icon_bank_035.png";
  import icon_bank_036 from "@/assets/icons/bank/icon_bank_036.png";
  import icon_bank_037 from "@/assets/icons/bank/icon_bank_037.png";
  import icon_bank_038 from "@/assets/icons/bank/icon_bank_038.png";
  import icon_bank_999 from "@/assets/icons/bank/icon_bank_999.png";
  import crypto_trc20_usdt from "@/assets/icons/crypto/crypto_trc20_usdt.png";
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";
  import HButton from "@/components/utils/HButton.vue";
  import {useHHttp} from "@/hooks/useHHttp.js";


  let useUser = useUserStore();
  let useHttp = useHHttp();
  const props = ref(hr.getRouteParams());
  const values = ref(['', '', '']);

  let type = props.value["type"];

  const showSelectModal = ref(false);
  const selectInfos = ref([]);

  const isCanPressOkBtn = ref(false);

  function clickSelect(value) {
    if (type === 1) {//银行卡
      values.value[2] = value;
    } else {
      values.value[0] = value;
    }
    showSelectModal.value = false;

    checkLoginBtnVisible();
  }

  function openSelectBank() {
    selectInfos.value = [
      {
        "icon": icon_bank_003,
        "label": '中国农业银行',
        "value": '中国农业银行',
      },
      {
        "icon": icon_bank_004,
        "label": '中国工商银行',
        "value": '中国工商银行',
      },
      {
        "icon": icon_bank_009,
        "label": '中国邮政储蓄银行',
        "value": '中国邮政储蓄银行',
      },
      {
        "icon": icon_bank_002,
        "label": '中国银行',
        "value": '中国银行',
      },
      {
        "icon": icon_bank_005,
        "label": '中国建设银行',
        "value": '中国建设银行',
      },
      {
        "icon": icon_bank_006,
        "label": '招商银行',
        "value": '招商银行',
      },
      {
        "icon": icon_bank_007,
        "label": '交通银行',
        "value": '交通银行',
      },
      {
        "icon": icon_bank_008,
        "label": '广东发展银行(广发银行)',
        "value": '广发银行',
      },
      {
        "icon": icon_bank_039,
        "label": '上海浦东发展银行(浦发银行)',
        "value": '浦发银行',
      },
      {
        "icon": icon_bank_017,
        "label": '中国光大银行',
        "value": '中国光大银行',
      },
      {
        "icon": icon_bank_016,
        "label": '兴业银行',
        "value": '兴业银行',
      },
      {
        "icon": icon_bank_040,
        "label": '中信银行',
        "value": '中信银行',
      },
      {
        "icon": icon_bank_041,
        "label": '中国民生银行',
        "value": '中国民生银行',
      },
      {
        "icon": icon_bank_042,
        "label": '平安银行',
        "value": '平安银行',
      },
      {
        "icon": icon_bank_043,
        "label": '成都银行',
        "value": '成都银行',
      },
      {
        "icon": icon_bank_044,
        "label": '东莞银行',
        "value": '东莞银行',
      },
      {
        "icon": icon_bank_045,
        "label": '苏州银行',
        "value": '苏州银行',
      },
      {
        "icon": icon_bank_046,
        "label": '广东省农村信用社(广东农信)',
        "value": '广东省农村信用社',
      },
      {
        "icon": icon_bank_047,
        "label": '云南省农村信用社(云南农信)',
        "value": '云南省农村信用社',
      },
      {
        "icon": icon_bank_048,
        "label": '安徽省农村信用社(安徽农信)',
        "value": '安徽省农村信用社',
      },
      {
        "icon": icon_bank_049,
        "label": '浙江省农村信用社(浙江农信)',
        "value": '浙江省农村信用社',
      },
      {
        "icon": icon_bank_049,
        "label": '浙江农商联合银行',
        "value": '浙江省农村信用社',
      },
      {
        "icon": icon_bank_050,
        "label": '四川省农村信用社(四川农信)',
        "value": '四川省农村信用社',
      },
      {
        "icon": icon_bank_051,
        "label": '新疆农村信用社(新疆农信)',
        "value": '新疆农村信用社',
      },
      {
        "icon": icon_bank_052,
        "label": '重庆农村商业银行(重庆农商行)',
        "value": '重庆农村商业银行',
      },
      {
        "icon": icon_bank_053,
        "label": '东莞农村商业银行',
        "value": '东莞农村商业银行',
      },
      {
        "icon": icon_bank_054,
        "label": '北京农村商业银行',
        "value": '北京农村商业银行',
      },
      {
        "icon": icon_bank_055,
        "label": '成都农商银行',
        "value": '成都农商银行',
      },
      {
        "icon": icon_bank_018,
        "label": '恒丰银行',
        "value": '恒丰银行',
      },
      {
        "icon": icon_bank_019,
        "label": '华夏银行',
        "value": '华夏银行',
      },
      {
        "icon": icon_bank_010,
        "label": '北京银行',
        "value": '北京银行',
      },
      {
        "icon": icon_bank_011,
        "label": '上海银行',
        "value": '上海银行',
      },
      {
        "icon": icon_bank_028,
        "label": '江苏银行',
        "value": '江苏银行',
      },
      {
        "icon": icon_bank_012,
        "label": '天津银行',
        "value": '天津银行',
      },
      {
        "icon": icon_bank_013,
        "label": '重庆银行',
        "value": '重庆银行',
      },
      {
        "icon": icon_bank_014,
        "label": '浙商银行',
        "value": '浙商银行',
      },
      {
        "icon": icon_bank_015,
        "label": '东莞银行',
        "value": '东莞银行',
      },
      {
        "icon": icon_bank_024,
        "label": '湖北银行',
        "value": '湖北银行',
      },
      {
        "icon": icon_bank_026,
        "label": '徽商银行',
        "value": '徽商银行',
      },
      {
        "icon": icon_bank_027,
        "label": '吉林银行',
        "value": '吉林银行',
      },
      {
        "icon": icon_bank_023,
        "label": '河北银行',
        "value": '河北银行',
      },
      {
        "icon": icon_bank_031,
        "label": '内蒙古银行',
        "value": '内蒙古银行',
      },
      {
        "icon": icon_bank_032,
        "label": '宁夏银行',
        "value": '宁夏银行',
      },
      {
        "icon": icon_bank_033,
        "label": '齐鲁银行',
        "value": '齐鲁银行',
      },
      {
        "icon": icon_bank_034,
        "label": '青海银行',
        "value": '青海银行',
      },
      {
        "icon": icon_bank_035,
        "label": '厦门银行',
        "value": '厦门银行',
      },
      {
        "icon": icon_bank_037,
        "label": '西安银行',
        "value": '西安银行',
      },
      {
        "icon": icon_bank_038,
        "label": '杭州银行',
        "value": '杭州银行',
      },
      {
        "icon": icon_bank_036,
        "label": '华润银行',
        "value": '华润银行',
      },
      {
        "icon": icon_bank_999,
        "label": '其他银行(手动输入)',
        "value": '',
      },
    ];
    showSelectModal.value = true;
  }

  function sortWithDrawDefaultAndUpdateTick() {
    for (let type in useUser.withdrawMap) {
      if (useUser.withdrawMap[type] != null &&
          useUser.withdrawMap[type].length > 1) {
        useUser.withdrawMap[type].sort((a, b) => {
          if ((a["Default"] === 1) &&
              !(b["Default"] === 1)) {
            return -1;
          } else if (!(a["Default"] === 1) && b["Default"] === 1) {
            return 1;
          } else {
            return a["UpdatedTick"] - b["UpdatedTick"];
          }
        });
      }
    }
  }

  function clickSaveBtn() {
    useHttp.request("/app/profile/add-withdraw2",
        (data) => {
          if (type === 1 || type === 3 || type === 4) {
            useUser.realName =
                values.value[0];
          }
          useUser.withdrawMap =
              hcf.processWithDrawData(data["Data"]);

          sortWithDrawDefaultAndUpdateTick();

          hr.goBack();
        }, {
          params: {
            "Id": "",
            "AppId": useHttp.appId,
            "UserId": useHttp.userId,
            "Type": type,
            "RealName": (type === 1 || type === 3 || type === 4)
                ? values.value[0]
                : null,
            "BankCard": values.value[1],
            "BankName": type !== 1
                ? (type === 3 || type === 4)
                    ? props.value['name']
                    : values.value[0]
                : values.value[2],
            "Default": 1,
          }
        });
  }

  function checkLoginBtnVisible() {
    let isCanSave = true;
    for (let i = 0; i < (type === 1?3:2); i++) {
      if (values.value[i].trim() === "") {
        isCanSave = false;
        break;
      }
    }
    isCanPressOkBtn.value = isCanSave;
  }


  function openSelectCrypto() {
    selectInfos.value = [
      {
        "icon": crypto_trc20_usdt,
        "label": 'TRC20-USDT',
        "value": 'TRC20-USDT',
      },
    ];
    showSelectModal.value = true;
  }


  let allInputInfos = ref(type === 3 || type === 4
      ? [
        {
          "title": "真实姓名",
          "hintText": "请输入姓名",
          "inputValue": useUser.realName,
          "keyboardType": "any",
          "isCantEdit": useUser.realName !== "",
        },
        {
          "title": type === 4 ? "微信号" : "支付宝号",
          "hintText": `请输入${type === 4 ? "微信" : "支付宝"}账号`,
          "inputValue": "",
          "keyboardType": "any",
        },
      ]
      : type === 1
          ? [
            {
              "title": "真实姓名",
              "hintText": "请输入姓名",
              "inputValue": useUser.realName,
              "keyboardType": "any",
              "isCantEdit": useUser.realName !== "",
            },
            {
              "title": "银行卡",
              "hintText": "请输入银行卡卡号",
              "inputValue": "",
              "keyboardType": "number",
            },
            {
              "title": "开户银行",
              "hintText": "请输入开户银行",
              "inputValue": "",
              "keyboardType": "any",
              "rightText": "选择开户行",
              "rightCallback": openSelectBank,
              "key": "tag_bind_card_select_bank"
            },
          ]
          : [
            {
              "title": type === 2 ? "转账网络" : "钱包名称",
              "hintText": type === 2 ? "请选择..." : "请输入...",
              "inputValue": "",
              "keyboardType": "any",
              "isCantEdit": type === 2,
              "isFirstAutoFocus": true,
              "rightText": type === 2 ? "选择转账网络" : "",
              "rightCallback":
                  type === 2 ? openSelectCrypto : null,
              "key": "tag_bind_card_select_crypto"
            },
            {
              "title": type === 2
                  ? "转账地址"
                  : type === 4
                      ? "微信号"
                      : "钱包地址",
              "hintText": "请输入...",
              "inputValue": "",
              "keyboardType": "any",
              "maxLength": 50,
            },
          ]);

  for (let i = 0; i < allInputInfos.value.length; i++) {
    values.value[i] = allInputInfos.value[i]["inputValue"] ?? "";
  }


</script>


<style scoped>
  ::v-deep(.van-field--disabled .van-field__label) {
    color: var(--van-text-color);
  }

  .tAddWithdrawParentDiv {
    display: flex;
    flex-direction: column;
    padding-top: 10px;
  }

</style>
